import { dontUpsell } from '@trello/config';
import {
  useUpgradePromptDismissMessageMutation,
  useUpgradePromptQuery,
} from '@trello/graphql/generated';
import { useState } from 'react';

interface UseUpgradePrompt {
  (args: { orgId: string; messageId: string; allowUpsell?: boolean }): {
    dismissMessage: () => void;
    hidePrompt: () => void;
    shouldDisplayUpgradePrompt: boolean;
  };
}

// UpgradePrompt display state logic
export const useUpgradePrompt: UseUpgradePrompt = ({
  orgId,
  messageId,
  allowUpsell,
}) => {
  // Apollo hooks
  const { data } = useUpgradePromptQuery({
    variables: {
      memberId: 'me',
      orgId,
    },
  });
  const [
    addOneTimeMessagesDismissed,
  ] = useUpgradePromptDismissMessageMutation();

  const isFreeTeam = Boolean(
    data?.organization && !data.organization.products.length,
  );

  const isMessageDismissed = Boolean(
    data?.member?.oneTimeMessagesDismissed?.find(
      (msgId) => msgId === messageId,
    ),
  );

  // Manual override to speed up hiding the prompt
  const [shouldHidePrompt, togglePrompt] = useState(false);

  const shouldDisplayUpgradePrompt = Boolean(
    (!dontUpsell || allowUpsell) &&
      isFreeTeam &&
      !shouldHidePrompt &&
      !isMessageDismissed,
  );

  return {
    dismissMessage() {
      addOneTimeMessagesDismissed({
        variables: {
          memberId: 'me',
          messageId,
        },
      });
    },
    hidePrompt() {
      togglePrompt(true);
    },
    shouldDisplayUpgradePrompt,
  };
};
